<template>
    <div class="forum-index">
        <div class="contain">
            <!-- 上方按钮 -->
            <el-row class="button-group">
                <el-button
                    size="small"
                    icon="el-icon-search"
                    @click="searchB()"
                    class="more-search-css"
                ></el-button>
                <el-input
                    placeholder="请输入关键字搜索"
                    v-model="searchInput"
                    class="search-input"
                    v-show="showS"
                    @input="keyWords(searchInput,lb)"
                ></el-input>
                <el-button
                    size="small"
                    v-for="(item, index) in seachButtonH"
                    :key="index"
                    :class="item.checked?'select-checked':'no-checked'"
                    @click="select(item)"
                >{{ item.name }}</el-button>

                <el-dropdown trigger="click" @command="select1" v-if="isDisplay">
                    <el-button size="small" :class="more?'select-checked':'no-checked'">
                        更多
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-for="(item, index) in seachButtonD"
                            :key="index"
                            :command="item"
                            :class="item.checked?'select-checked':'no-checked'"
                        >{{item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-row>
            <el-row :gutter="20" class="video-list" style="margin:0px auto">
                <el-col :span="6" v-for="(item, index) in videoList" :key="index">
                    <div @click="jiangtangV(item.type,item.id)">
                        <div class="video-outer common-img-outer">
                            <img :src="$store.state.imgUrl+item.stanceImg" alt="" style="width:100%" v-if="item.type == '1'">
                            <video :src="$store.state.imgUrl+item.videoFile" controls controlslist="nodownload disablePictureInPicture nofullscreen noremoteplayback" disablePictureInPicture="true" :poster="item.stanceImg" v-else></video>
                        </div>
                        <div class="forum-title">{{limitMaxWords(14,item.name) }}</div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="pageInfo.total"
                        :page-size="pageInfo.pageSize"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: "ForumIndex",
    data() {
        return {
            searchInput: "", //文本框搜索内容
            showS: false, //搜索框不显示
            more: false, //更多没有选中
            lb: "", //分类id
            seachButtonH: [], //搜索横着显示的
            seachButtonD: [], //搜索竖着显示的
            isDisplay: false, //搜索的更多按钮不显示
            videoList: [] //讲堂数组
        };
    },
    methods: {
        //选页
        handleCurrentChange(v) {
            let that = this;
            // console.log(v);
            that.pageInfo.pageNum = v; //当前页
            that.getList(that.searchInput, that.lb,v);
        },
        //搜索按钮
        searchB() {
            let that = this;
            if (that.showS) {
                that.showS = false;
            } else {
                that.showS = true;
            }
        },
        //searchInput搜索框
        keyWords(searchInput) {
            let that = this;
            // 将全部选择效果删除
            for (let c of that.seachButtonH) {
                if (c.id == "全部") {
                    c.checked = false;
                }
            }
            this.getList(searchInput,that.lb);
        },
        //得到搜索的条件
        getSearchButton() {
            let that = this;
            let url = "/medicineForum/categoryList";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                        that.seachButtonH = [];
                        that.seachButtonD = [];
                        let arr = [];
                        arr = res.data.data;
                        for (let i = 0; i < arr.length; i++) {
                            if (i < 8) {
                                that.isDisplay = false;
                                if (arr[i].id == "全部") {
                                    that.seachButtonH.push({
                                        id: arr[i].id,
                                        name: arr[i].name,
                                        checked: true
                                    });
                                } else {
                                    that.seachButtonH.push({
                                        id: arr[i].id,
                                        name: arr[i].name,
                                        checked: false
                                    });
                                }
                            } else {
                                that.isDisplay = true;
                                that.seachButtonD.push({
                                    id: arr[i].id,
                                    name: arr[i].name,
                                    checked: false
                                });
                            }
                            // console.log(that.seachButtonH);
                            // console.log(that.seachButtonD);
                        }
                    } else {
                        that.$message.error(res.message);
                    }
                })
                .catch(() => {
                    that.$message.error("网络错误！");
                });
        },
        //searchInput搜索框,lb讲堂分类
        getList(searchInput, lb, pageNum) {
            let that = this;
            if (pageNum) {
                that.pageInfo.pageNum = pageNum;
            } else {
                that.pageInfo.pageNum = 1;
            }
            console.log("文本框关键字:" + searchInput);
            console.log("讲堂分类id:" + lb);
            console.log("当前页:" + pageNum);
            let url = "/medicineForum/pageByCategory";
            let parmas = {
                category: lb,
                name: searchInput,
                pageNum: that.pageInfo.pageNum,
                pageSize: that.pageInfo.pageSize
            };
            that.$http
                .post(url, parmas)
                .then(res => {
                    if (res.data.code == 200) {
                        that.pageInfo.total = res.data.data.total;
                        that.pageInfo.pageSize = res.data.data.pageSize;
                        that.videoList = [];
                        that.videoList = res.data.data.list.map((item, index) => {
                            return {
                                author: item.author,
                                jianshu: item.jianshu,
                                id: item.id,
                                name: item.name,
                                stanceImg: item.stanceImg,
                                type: item.type,
                                videoFile: item.videoFile,
                            };
                        });
                    } else {
                        that.$message.error(res.message);
                    }
                })
                .catch(() => {
                    that.$message.error("网络错误！");
                });
        },
        // 横向选择
        select(v) {
            let that = this;
            for (let c of that.seachButtonH) {
                c.checked = false;
            }
            v.checked = true;
            if(v.id == "全部"){
                that.searchInput = "";
            }
            that.more = false;
            that.lb = v.id;
            for (let c of that.seachButtonD) {
                c.checked = false;
            }
            that.getList(that.searchInput, that.lb);
        },
        // 纵向选择
        select1(command) {
            let that = this;
            for (let c of that.seachButtonD) {
                c.checked = false;
            }
            command.checked = true;
            that.more = true;
            that.lb = command.id;
            for (let c of that.seachButtonH) {
                c.checked = false;
            }
            that.getList(that.searchInput, that.lb);
        }
    },
    created() {
        let that = this;
        that.getSearchButton();
        that.getList();
    }
};
</script>

<style scoped>

video::-webkit-media-controls-fullscreen-button {
display: none;
}
video::-webkit-media-controls-timeline {
display: none;
}
video::-webkit-media-controls-current-time-display{
display: none;
}
video::-webkit-media-controls-time-remaining-display {
display: none;
}
video::-webkit-media-controls-mute-button {
display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
display: none;
}
video::-webkit-media-controls-volume-slider {
display: none;
}
/* 隐藏seeking手柄 */
video::-webkit-media-controls-seek-forward-button {
  display: none;
}
video::-webkit-media-controls-seek-back-button {
  display: none;
}
.no-checked {
    /* border: none; */
    margin-bottom: 0px;
}
.video-outer {
    width: 239px;
    height: 135px;
}
.el-button:nth-of-type(1){
    margin-left:0;
}
.button-group {
    /* text-align: center; */
    padding: 30px 0px 30px;
    margin-left: 10px;
}
.button-group .el-button:hover {
    background-color: #f64420;
    color: white;
    border: 1px solid white;
}
video {
    width: 100%;
}
.forum-title {
    font-size: 16px;
    line-height: 50px;
    cursor: pointer;
    color: #333333;
}
.search-more-down {
    color: #888888 !important;
    background-color: #f8f8f8 !important;
    border: solid 1px #dddddd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ForumIndex.vue